import type {ViewerConfigs} from '3d'

const defaultBlueColor = 0x4183c4

export const defaultViewerConfig = (): ViewerConfigs => ({
  color: defaultBlueColor,
})
